import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { setToken } = useContext(AuthContext);

  useEffect(() => {
    setToken('');
    localStorage.removeItem('id_token');
    nav('/login');
  }, []);

  return <div>{t('logoutPage.logoutAlert')}</div>;
}
